import { useMemo } from 'react';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { useGetPublicProductsV2Query } from '../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc.hooks';
import { getHubsSignupCTA } from '../utils/hubsSignupCta';
import { getNonMerchandiseIdProduct, getSourceIdFromTrackingData } from '../utils/productIdentifier';
import { deriveProductLineFromSkuCategory } from '../utils/productLine';
import { getHubsSignupUrl } from '../utils/signupUrl';
export const useSignupContext = ({
  apiName,
  ctaType,
  trackingData
}) => {
  var _productsData$product, _productSku$productLe;
  const sourceId = getSourceIdFromTrackingData(trackingData);
  const nonMerchandiseIdProduct = getNonMerchandiseIdProduct(apiName);
  const {
    data: productsData,
    loading,
    error
  } = useGetPublicProductsV2Query({
    variables: {
      productApiNames: [apiName]
    }
  });
  const hubsSignupUrl = useMemo(() => getHubsSignupUrl(), []);
  const productSku = productsData === null || productsData === void 0 || (_productsData$product = productsData.productsByName) === null || _productsData$product === void 0 ? void 0 : _productsData$product[apiName];
  const productLine = useMemo(() => deriveProductLineFromSkuCategory(productSku === null || productSku === void 0 ? void 0 : productSku.skuCategoryName), [productSku === null || productSku === void 0 ? void 0 : productSku.skuCategoryName]);
  const productLevel = readUnhandledEnumCase((_productSku$productLe = productSku === null || productSku === void 0 ? void 0 : productSku.productLevel) !== null && _productSku$productLe !== void 0 ? _productSku$productLe : '') || undefined;
  const hubsSignupCta = useMemo(() => {
    if (!nonMerchandiseIdProduct && !productLine && !productLevel) {
      return '';
    }
    return getHubsSignupCTA({
      ctaType,
      sourceId,
      apiName,
      nonMerchandiseIdProduct,
      productLine,
      productLevel,
      pathname: window.location.pathname
    });
  }, [ctaType, sourceId, apiName, nonMerchandiseIdProduct, productLine, productLevel]);
  return {
    productsData,
    productSku,
    productLine,
    productLevel,
    hubsSignupUrl,
    hubsSignupCta,
    loading,
    error
  };
};